export default __webpack_public_path__ + "static/basic_attention_token-19641f15fd6fca95d805ace0d5720a61.png";